import React, { useEffect } from "react";
import sal from "sal.js";

/**
 * Componente que muestra los Términos y Condiciones.
 * Se utiliza la librería sal.js para aplicar animaciones a la sección.
 *
 * @returns {JSX.Element} - Elemento que renderiza los Términos y Condiciones.
 */
const TermsAndCondition = () => {
  useEffect(() => {
    sal();
  }, []);

  return (
    <div className="rainbow-pricing-area rainbow-section-gap">
      <div className="container-fluid">
        <div className="wrapper rainbow-contact-area">
          <div className="container pl--0 pr--0">
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="section-title text-center"
                  data-sal="slide-up"
                  data-sal-duration="400"
                  data-sal-delay="150"
                >
                  <h2 className="subtitle text-2xl font-bold">
                    <span className="theme-gradient">
                      Términos y Condiciones
                    </span>
                  </h2>
                </div>
              </div>
            </div>

            {/* Sección de contenido de los términos */}
            <div className="row mt--40 row--15">
              <div className="col-lg-12">
                <h4>1. Identificación del proveedor</h4>
                <p>
                  <strong>TutorIA+</strong> es una plataforma web desarrollada y
                  operada por TutorIA+, con <strong>RUC 10481559613</strong>,
                  domiciliada en{" "}
                  <strong>
                    Calle Cerro Prieto 255, Santiago de Surco, Lima, Perú
                  </strong>
                  . Para consultas, puedes contactarnos a través del correo
                  electrónico{" "}
                  <a
                    className="btn-read-more"
                    href="mailto:contacto@tutoriaplus.com"
                  >
                    <span>contacto@tutoriaplus.com</span>
                  </a>
                  .
                </p>

                <h4>2. Descripción de la aplicación</h4>
                <p>
                  TutorIA+ es una plataforma educativa basada en inteligencia
                  artificial que ayuda a docentes y educadores a crear clases
                  completas de forma más rápida. Entre sus funcionalidades,
                  TutorIA+ permite generar
                  <strong>
                    {" "}
                    planes de lección, evaluaciones, presentaciones y otros
                    recursos educativos
                  </strong>
                  , facilitando la preparación de clases y la planificación
                  académica.
                </p>
                <p>
                  El acceso a la plataforma requiere una conexión a Internet y
                  un navegador web compatible.
                </p>

                <h4>3. Aceptación de los términos y condiciones</h4>
                <p>
                  Al utilizar TutorIA+, el usuario acepta expresamente estos{" "}
                  <strong>Términos y Condiciones</strong>. Si no está de acuerdo
                  con ellos, deberá abstenerse de usar la plataforma.
                </p>

                <h4>4. Uso responsable de la plataforma</h4>
                <p>
                  El usuario se compromete a utilizar la plataforma de manera
                  responsable y ética, garantizando que:
                </p>
                <ul className="content-list">
                  <li>
                    No hará uso indebido o malintencionado de las
                    funcionalidades proporcionadas por la plataforma.
                  </li>
                  <li>
                    No compartirá información engañosa o perjudicial generada
                    por la inteligencia artificial.
                  </li>
                  <li>
                    No realizará actividades fraudulentas o que vulneren
                    derechos de terceros.
                  </li>
                </ul>

                <h4>5. Uso personal y no compartido de la cuenta</h4>
                <p>
                  El acceso a la cuenta en TutorIA+ es personal e
                  intransferible. No está permitido compartir credenciales ni
                  permitir que terceros utilicen la cuenta registrada. TutorIA+
                  se reserva el derecho de suspender o cancelar cuentas en caso
                  de detección de uso compartido o fraudulento.
                </p>

                <h4>6. Propiedad intelectual y derechos de autor</h4>
                <p>
                  <strong>
                    TutorIA+ permite que los usuarios copien, usen y distribuyan
                    los resultados generados por la plataforma
                  </strong>{" "}
                  (por ejemplo, planes de lección, evaluaciones, presentaciones
                  y otros materiales educativos), ya que están diseñados para
                  ser utilizados en la práctica educativa.
                </p>
                <p>
                  El aplicativo y su diseño están protegidos por la normativa
                  vigente sobre derechos de autor. Esto incluye las páginas,
                  pantallas, interfaz gráfica, algoritmos y cualquier otro
                  componente.
                </p>
                <p>
                  <strong>
                    TutorIA+ permite que los usuarios copien, usen y distribuyan
                    los resultados generados por las herramientas
                  </strong>{" "}
                  (por ejemplo, planes de lección, rúbricas, evaluaciones), ya
                  que estas están diseñadas para ser utilizadas en la práctica
                  educativa.
                </p>
                <p>Sin embargo, está estrictamente prohibido:</p>
                <ul className="content-list">
                  <li>
                    Modificar, distribuir o reproducir partes del código fuente,
                    diseño o funcionalidades de la plataforma sin autorización
                    expresa.
                  </li>
                  <li>
                    Utilizar técnicas de ingeniería inversa para acceder al
                    funcionamiento interno de TutorIA+.
                  </li>
                  <li>
                    Copiar o replicar la plataforma en su totalidad o en partes
                    significativas sin consentimiento.
                  </li>
                </ul>

                <h4>7. Uso de inteligencia artificial y limitaciones</h4>
                <p>
                  TutorIA+ utiliza modelos de inteligencia artificial para
                  generar contenido educativo. Sin embargo, el usuario debe
                  considerar lo siguiente:
                </p>
                <ul className="content-list">
                  <li>
                    <strong>
                      La inteligencia artificial puede cometer errores
                    </strong>
                    .
                  </li>
                  <li>
                    Se recomienda siempre revisar, validar y adaptar el
                    contenido generado antes de su uso en el aula o cualquier
                    entorno educativo.
                  </li>
                  <li>
                    TutorIA+ fomenta un uso ético, transparente y responsable de
                    la inteligencia artificial, promoviendo la supervisión
                    activa de los docentes.
                  </li>
                </ul>

                <h4>8. Planes y formas de pago</h4>
                <p>TutorIA+ ofrece dos planes de suscripción:</p>
                <ul className="content-list">
                  <li>
                    <strong>Plan Ilimitado:</strong> Acceso completo a TutorIA+
                    para un usuario individual.
                  </li>
                  <li>
                    <strong>Plan Institucional:</strong> Acceso para
                    instituciones educativas que desean brindar TutorIA+ a sus
                    docentes.
                  </li>
                </ul>
                <p>
                  Al suscribirse al <strong>Plan Ilimitado</strong>, se realiza
                  un primer pago inmediato correspondiente al período
                  contratado. A partir de ese momento, se activará un débito
                  automático mensual por el mismo importe hasta que el usuario
                  decida cancelar la suscripción.
                </p>
                <p>
                  Los pagos en TutorIA+ se procesan a través de{" "}
                  <strong>pasarelas de pago certificadas</strong> que cumplen
                  con los estándares de seguridad internacional, asegurando la
                  protección de la información de tarjetas para pagos
                  recurrentes.
                </p>

                <h4>9. Política de devoluciones</h4>
                <p>
                  TutorIA+ no ofrece reembolsos por suscripciones ya adquiridas,
                  salvo en casos excepcionales que serán evaluados
                  individualmente.
                </p>
                <p>
                  Si el usuario experimenta problemas con la plataforma que
                  impiden su uso adecuado, podrá contactar a nuestro equipo de
                  soporte para buscar una solución.
                </p>
                <p>
                  TutorIA+ podrá considerar solicitudes de reembolso o ajustes
                  en la suscripción bajo circunstancias especiales.
                </p>
                <p>
                  Para más información, consulta{" "}
                  <a className="btn-read-more" href="/politica-de-devoluciones">
                    <span>nuestra política de devoluciones</span>
                  </a>
                  .
                </p>

                <h4>10. Privacidad y protección de datos</h4>
                <p>
                  TutorIA+ respeta la privacidad de sus usuarios y cumple con la{" "}
                  <strong>
                    Ley N° 29733 – Ley de Protección de Datos Personales en Perú
                  </strong>
                  .
                </p>
                <p>
                  Los datos recopilados son utilizados exclusivamente para el
                  funcionamiento de la plataforma y no se comparten con terceros
                  sin autorización.
                </p>
                <p>
                  Los usuarios pueden ejercer sus derechos de acceso,
                  rectificación, cancelación y oposición (ARCO) sobre sus datos
                  enviando una solicitud a{" "}
                  <a
                    className="btn-read-more"
                    href="mailto:contacto@tutoriaplus.com"
                  >
                    <span>contacto@tutoriaplus.com</span>
                  </a>
                  .
                </p>

                <h4>11. Responsabilidad y limitaciones</h4>
                <ul className="content-list">
                  <li>
                    TutorIA+ no garantiza que el servicio esté disponible de
                    forma ininterrumpida o libre de errores.
                  </li>
                  <li>
                    TutorIA+ no se responsabiliza por el mal uso de los
                    contenidos generados por la inteligencia artificial.
                  </li>
                  <li>
                    TutorIA+ no es responsable por pérdidas o daños derivados
                    del uso inadecuado de la plataforma.
                  </li>
                </ul>

                <h4>12. Modificaciones en los términos y condiciones</h4>
                <p>
                  Nos reservamos el derecho de modificar estos términos en
                  cualquier momento. Los cambios se publicarán en la plataforma
                  y entrarán en vigencia desde su publicación.
                </p>

                <h4>13. Legislación aplicable y jurisdicción</h4>
                <p>
                  Estos términos se rigen por las leyes de la República del
                  Perú. En caso de disputas, las partes se someten a la
                  jurisdicción de los tribunales de Lima, Perú.
                </p>

                <h4>14. Libro de reclamaciones</h4>
                <p>
                  TutorIA cuenta con un{" "}
                  <strong>Libro de Reclamaciones Virtual</strong>, conforme a la
                  normativa de <strong>INDECOPI</strong>. Si el usuario desea
                  registrar un reclamo, puede hacerlo en{" "}
                  <a className="btn-read-more" href="/libro-de-reclamaciones">
                    <span>Libro de Reclamaciones</span>
                  </a>
                  .
                </p>

                <p>
                  <strong>Fecha de última actualización:</strong> 30 de marzo de
                  2026
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndCondition;
